// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"q6erq","block":"_228fw","text":"_2NU-r","img":"ZHh5h","container":"_1XY9q"};